import { useAuth } from './use-auth';
import { useGetProfileQuery } from '../store/queries/users';

export const useOnboarding = () => {
  const { isAuthenticated } = useAuth();
  const { data: profileData, isLoading } = useGetProfileQuery(undefined, { skip: !isAuthenticated });

  const isOnboardingComplete = (profileData?.onboarding?.finished ?? false) && Boolean(profileData?.personalizedPlan);

  return { isOnboardingComplete, isProfileLoading: isLoading || !profileData };
};
